<template>
    <div class="maintenance-page vh-100 px-4 py-5 my-5 text-center">
        <img
            class="d-block mx-auto mb-4"
            :src="themeSetting('logo')"
            alt="Logo"
            v-if="themeSetting('logo')"
            height="57"
        />
        <img
            class="d-block mx-auto mb-4"
            :src="asset('/img/logos/logo-monevo.svg?v=2')"
            alt="Monevo"
            height="57"
            v-else
        />

        <div class="container">
            <h1 class="heading">Maintenance in progress</h1>
            <div class="col-lg-8 mx-auto">
                <p class="subheading lead mb-4">
                    We are currently performing a scheduled migration to improve our services. Our website is
                    temporarily unavailable during this time.
                </p>

                <p class="subheading lead mb-4">
                    We apologise for any inconvenience and appreciate your patience. Please check back again soon.
                </p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['isStaticPage'],
}
</script>

<style lang="scss" scoped>
@import '~scss/mixins/rem';
@import '~scss/settings/responsive';

.maintenance-page {
    background-color: var(--results-hero-banner-background);

    .heading {
        font-size: rem(30px);
        font-weight: 600;
        color: var(--hero-offer-color);
        font-family: var(--heading-font);

        @media screen and (min-width: $bp-small) {
            font-size: rem(50px);
        }
    }

    .subheading {
        font-size: rem(16px);
        color: var(--hero-offer-color);
        font-family: var(--heading-font);

        @media screen and (min-width: $bp-small) {
            font-size: rem(24px);
        }
    }
}
</style>
